import {
    Grid,
    type GridProps,
    type PandaBreakpointConditions,
    type ResponsiveVariant,
} from "@octopus-energy/coral/atoms"
import { mergeResponsiveProps } from "@oefr/ui"
import { DataGridItem } from "./components/DataGridItem"
import { DataGridLabel } from "./components/DataGridLabel"
import { DataGridValue } from "./components/DataGridValue"

type DataProps = Omit<GridProps, "gridTemplateColumns"> & { columns: ResponsiveVariant<number> }

const DEFAULT_GRID_PROPS: GridProps = {
    columnGap: "sm",
    rowGap: "lg",
}

function getGridTemplateColumns(columns: ResponsiveVariant<number>) {
    if (typeof columns === "number") {
        return `repeat(${columns}, 1fr)`
    }

    return Object.entries(columns).reduce<Partial<Record<keyof PandaBreakpointConditions, string>>>(
        (acc, [breakpoint, value]) => {
            acc[breakpoint as keyof PandaBreakpointConditions] = `repeat(${value}, 1fr)`

            return acc
        },
        {}
    )
}

export function DataGrid(props: DataProps) {
    const gridProps = mergeResponsiveProps(DEFAULT_GRID_PROPS, {
        ...props,
        gridTemplateColumns: getGridTemplateColumns(props.columns),
    })

    return <Grid {...gridProps} />
}

DataGrid.Item = DataGridItem
DataGrid.Label = DataGridLabel
DataGrid.Value = DataGridValue
